import React from 'react';
import PropTypes from 'prop-types';
import {
  DetailUpperBoxContainerStyled,
  DetailUpperBoxContainerTitleStyled,
  DetailUpperBoxContainerContentStyled,
} from './styles/DetailUpperBoxItemStyled';

const DetailUpperBoxItem = ({ itemTitle, children }) => {
  return (
    <>
      <DetailUpperBoxContainerStyled>
        <DetailUpperBoxContainerTitleStyled>
          <span>{itemTitle}</span>
        </DetailUpperBoxContainerTitleStyled>
        <DetailUpperBoxContainerContentStyled>
          {children}
        </DetailUpperBoxContainerContentStyled>
      </DetailUpperBoxContainerStyled>
    </>
  );
};

DetailUpperBoxItem.propTypes = {
  itemTitle: PropTypes.string.isRequired,
  children: PropTypes.node.isRequired,
};

export default DetailUpperBoxItem;
